namespace $.$$ {

	export class $shm_hitalama_projects extends $.$shm_hitalama_projects {
		self() { return this }
		team() {
			return this.$.$shm_hitalama_app.Root( 0 ).team_current()
		}

		projects_map_ensure() {
			if( this.projects_map_id() ) return this.projects_map_id()
			const team = this.team()
			const domain = this.$.$shm_hitalama_domain.instance()
			const legacy = domain.Projects_map()?.remote()
			if( team && legacy && domain.team_records().length === 1 ) {
				team.map_rank_all( legacy )
				team.maps_list( null )?.add( legacy.link() )
				team.projects_map( legacy )
				return legacy.link().str
			}
			return $mol_wire_sync( this ).projects_map_create( this.records_for_map() )
		}

		@ $mol_mem
		records_for_map() {
			return this.$.$shm_projects_data.records()
				.filter( project => !project.archived )
				.filter( project => this.$.$shm_projects_access_view( project.id ) )
		}

		@ $mol_action
		projects_link_open( next?: Event | null ) {
			if( next === undefined ) return null
			next?.preventDefault()
			const map = this.projects_map_ensure()
			this.$.$mol_state_arg.dict({
				... this.$.$mol_state_arg.dict(),
				section: 'projects',
				project: null,
				project_tab: null,
				projects_map: map,
				shift_x: null,
				shift_y: null,
				zoom: null,
			})
			return next
		}

		@ $mol_action
		projects_map_create( projects: readonly $shm_projects_data_record[] ) {
			if( this.projects_map_id() ) return this.projects_map_id()

			const team = this.team()
			const list = team?.maps_list( null )
			if( !team || !list ) return ''

			const map = this.$.$shm_hitalama_map_templates.import_projects( projects, list.land().area_make(), team )
			team.map_rank_all( map )
			list.add( map.link() )
			team.projects_map( map )
			this.$.$mol_state_arg.dict({
				... this.$.$mol_state_arg.dict(),
				section: 'projects',
				project: null,
				project_tab: null,
				projects_map: map.link().str,
				shift_x: null,
				shift_y: null,
				zoom: null,
			})
			return map.link().str
		}

		@ $mol_mem
		override List_head() {
			const head = super.List_head()
			head.head_content = ()=> [ head.Title(), this.Help() ]
			head.Title().event_click = event => this.projects_link_open( event )
			return head
		}

		@ $mol_mem
		override Menu_page() {
			const page = super.Menu_page()
			page.body = ()=> [ this.Projects_menu() ]
			return page
		}

		override Pinned_map_book() {
			return this.maps().Book( this.projects_map_id() )
		}

		profile() {
			return this.$.$shm_hitalama_profile.current()
		}

		override projects_map_id( next?: string ) {
			const team = this.team()
			if( next !== undefined ) {
				if( next && !team?.maps_list()?.remote_list().some( map => map.link().str === next ) ) {
					return team?.projects_map()?.link().str ?? ''
				}
				team?.projects_map( next
					? this.$.$giper_baza_glob.Pawn( new this.$.$giper_baza_link( next ), this.$.$shm_hitalama_map )
					: null
				)
				this.$.$mol_state_arg.value( 'projects_map', null )
				return next
			}

			const opened = this.opened_map_id()
			if( opened && team?.maps_list()?.remote_list().some( map => map.link().str === opened ) ) return opened
			return team?.projects_map()?.link().str ?? ''
		}

		projects_menu_rows() {
			return [ this.Projects() ]
		}

		pinned_map_title() {
			return this.pinned_map().title() || 'Карта'
		}

		projects_arg() {
			return {
				project: null,
				project_tab: null,
				project_output: null,
				project_task: null,
				project_session: null,
				project_version: null,
				project_version_output: null,
				project_thinking: null,
				docs_file: null,
				goal_run: null,
				goal_iteration: null,
				session: null,
				// A navigation URL must not open the linked CRDT maps.
				projects_map: this.opened_map_id() || null,
			}
		}

		opened_map_id() {
			return this.$.$mol_state_arg.value( 'projects_map' ) ?? ''
		}

		pinned_map() {
			const id = this.projects_map_id()
			if( !id ) return $mol_fail( new Error( 'Карта для проектов не выбрана' ) )
			return this.$.$giper_baza_glob.Pawn( new this.$.$giper_baza_link( id ), this.$.$shm_hitalama_map )
		}

		override project_arg( id: string ) {
			return {
				... super.project_arg( id ),
				help: 'off',
				projects_map: null,
			}
		}

		override catalog_pages() {
			if( !this.project_selected() && !this.new_project_opened() ) {
				// Never read full records or map state before returning the cached list.
				// A non-book slot keeps book.pages_deep() from flattening the slow map.
				return this.projects_list_visible()
					? [ this.Menu_page(), this.Map_slot() ]
					: [ this.Map_slot() ]
			}
			return super.catalog_pages()
		}

	}

}
